import { createAction } from "redux-starter-kit";
import { CLOSE_EDIT_NOTE } from "../types";

const closeEditNote = () => createAction(CLOSE_EDIT_NOTE)();

export default closeEditNote;
